import PropTypes from 'prop-types';
import './style.css';

export const Display = ({ currentValue, previousValue, operator }) => {
  return (
    <div className="display">
      <div className="previous">
        {previousValue}
        {operator}
      </div>
      <div className="current">{currentValue}</div>
    </div>
  );
};

Display.propTypes = {
  currentValue: PropTypes.node,
  previousValue: PropTypes.node,
  operator: PropTypes.string,
};
